export default __webpack_public_path__ + "static/media/chapter-pc.0d9e7a51.jpg";